import type { AppEnv } from '@hc-frontend/core-context';

import type { Log } from '../../domain';
import type { PerformSafeLogRepository } from '../../domain/repositories';

export const consoleAdapter: (env: AppEnv) => PerformSafeLogRepository = (
  env,
) => {
  const isBackend = typeof window === 'undefined';
  const logger: (type: Log['type']) => (log: unknown) => void =
    isBackend && env !== 'prd' // Log pretty in non-prod backend environments
      ? () => (log) =>
          console.dir(log, {
            colors: true,
            sorted: true,
          })
      : (type) => console[type]; // For prod or frontend, use the default console methods

  return async (log) => {
    const printLog = logger(log.type);

    printLog({
      type: `[${log.context.toUpperCase()}-${log.type.toUpperCase()}]`,
      message: log.message,
      ...log.data,
    });
  };
};
